module.exports = __webpack_public_path__ + "static/img/yidi2.c419cc94.webp";